import { FC } from "react"
import { Box, TextField } from "@mui/material"
import { normalizeHex } from "../../model/shiftTypeColor"

interface ColorFieldProps {
  value: string
  onChange: (hex: string) => void
  disabled?: boolean
}

/**
 * input type="color" плюс hex-поле. На blur значение нормализуется: бэкенд color не
 * валидирует, поэтому мусор нельзя пускать дальше — иначе ячейка станет серой.
 */
export const ColorField: FC<ColorFieldProps> = ({
  value,
  onChange,
  disabled,
}) => (
  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
    <input
      type="color"
      aria-label="Выбрать цвет"
      value={normalizeHex(value)}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      style={{
        width: 40,
        height: 40,
        padding: 0,
        border: "none",
        background: "none",
        cursor: "pointer",
      }}
    />
    <TextField
      size="small"
      label="Цвет (hex)"
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      onBlur={(e) => onChange(normalizeHex(e.target.value))}
      sx={{ width: 130 }}
    />
  </Box>
)
